/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { parseCookie } from "../../payment/miscellaneous/parseCookie";

export function getExternalClientIdFromCookies() {
  const cookie = parseCookie(document.cookie);

  return (cookie as any)["MkHcClientId"];
}
